import { render, staticRenderFns } from "./TransactionProfilePersonDetails.vue?vue&type=template&id=eb7f59d8&scoped=true&"
import script from "./TransactionProfilePersonDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionProfilePersonDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransactionProfilePersonDetails.vue?vue&type=style&index=0&id=eb7f59d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7f59d8",
  null
  
)

export default component.exports